import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9ee5d1ea")

_pushScopeId("data-v-9ee5d1ea")
const _hoisted_1 = { class: "px-16 mb-32" }
const _hoisted_2 = { class: "tab df-middle" }
const _hoisted_3 = {
  src: "/img/cup/wt/tab@2x.png",
  class: "tab-img",
  ref: "tabImg",
  alt: ""
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("All")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("My followings")
const _hoisted_6 = {
  class: "p-16",
  style: {"background":"#432CAA","margin-top":"-1px","min-height":"300px"}
}
const _hoisted_7 = { class: "d-f" }
const _hoisted_8 = { class: "flex-1 c-white ml-12" }
const _hoisted_9 = { class: "f-bold f-nm" }
const _hoisted_10 = { class: "f-sm mt-4" }
const _hoisted_11 = { class: "shadow" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Last 3 days")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" You are on the Top list. Are you willing to disclose your positions? ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Pic = _resolveComponent("Pic")
  const _component_TheRankNumber = _resolveComponent("TheRankNumber")
  const _component_ColorText = _resolveComponent("ColorText")
  const _component_TheMasterPositions = _resolveComponent("TheMasterPositions")
  const _component_Nullable = _resolveComponent("Nullable")
  const _component_Holder = _resolveComponent("Holder")
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("img", _hoisted_3, null, 512),
        _createVNode("div", {
          class: ["t-item", {'active': _ctx.activeIndex===0}],
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.change(0)))
        }, [
          _createVNode(_component_t, { path: "cup_16" }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ], 2),
        _createVNode("div", {
          class: ["t-item", {'active': _ctx.activeIndex===1}],
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.change(1)))
        }, [
          _createVNode(_component_t, { path: "cup_17" }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ], 2)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_Holder, { content: _ctx.traders }, {
          default: _withId(() => [
            _createVNode(_component_Nullable, { content: _ctx.traders }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.traders, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    key: item.rank + Math.random(),
                    class: "master"
                  }, [
                    _createVNode("div", _hoisted_7, [
                      _createVNode(_component_Pic, {
                        src: item.avatar,
                        fallback: "/img/user/Avatar@2x.png",
                        width: "40",
                        height: "40",
                        class: "round avatar"
                      }, null, 8, ["src"]),
                      _createVNode("div", _hoisted_8, [
                        _createVNode("p", _hoisted_9, _toDisplayString(item.name || '--'), 1),
                        _createVNode("p", _hoisted_10, [
                          _createVNode("span", _hoisted_11, [
                            _createVNode(_component_TheRankNumber, {
                              rank: item.rank,
                              sm: "",
                              "by-desc": ""
                            }, null, 8, ["rank"]),
                            _createTextVNode(" " + _toDisplayString(item.rank), 1)
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.cupDateFormat(item.startDate)) + " - " + _toDisplayString(_ctx.cupDateFormat(item.endDate)), 1)
                        ])
                      ]),
                      _createVNode("div", null, [
                        _createVNode(_component_ColorText, {
                          value: item.profitability,
                          class: "f-xxl f-bold"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(item.profitability / 100) + "% ", 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]),
                        _createVNode(_component_t, {
                          as: "p",
                          path: "cup_18",
                          class: "f-xs c-grey"
                        }, {
                          default: _withId(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createVNode(_component_TheMasterPositions, { master: item }, null, 8, ["master"])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["content"])
          ]),
          _: 1
        }, 8, ["content"])
      ])
    ]),
    (!_ctx.opened)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "prompt p-a df-middle c-white f-sm px-16",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.prompt && _ctx.prompt(...args)))
        }, [
          _createVNode(_component_Pic, {
            src: "cup/wt/coupon_5",
            width: "40",
            height: "40"
          }),
          _createVNode(_component_t, {
            as: "p",
            path: "cup_34",
            class: "flex-1 ml-8"
          }, {
            default: _withId(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_Icon, {
            name: "caret-right",
            sm: ""
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
})